import { render, staticRenderFns } from "./lessonsSidebar.vue?vue&type=template&id=70133f7b"
import script from "./lessonsSidebar.vue?vue&type=script&lang=js"
export * from "./lessonsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports